/**
 * PortalLayout — shared base layout for all customer-type portals.
 * Wraps Header + a portal-specific sidebar + main content area.
 *
 * Usage: the parent (portal index) manages sidebarOpen state and
 * passes a fully-wired sidebar element plus the onMenuClick handler.
 */

import { Header } from '@/components/layout/Header'

interface PortalLayoutProps {
  /** The portal-specific sidebar (with isOpen/onClose already bound). */
  sidebar: React.ReactNode
  /** Called when the hamburger menu button is tapped on mobile. */
  onMenuClick: () => void
  children: React.ReactNode
}

export function PortalLayout({ sidebar, onMenuClick, children }: PortalLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <Header onMenuClick={onMenuClick} />

      <div className="flex">
        {sidebar}

        <main className="flex-1 p-4 lg:p-8">
          <div className="mx-auto max-w-7xl">{children}</div>
        </main>
      </div>
    </div>
  )
}
